import React, { useState } from "react";
import PersonDebriefManager from "./childDebriefFormsManager/person-debrief-manager";
import BodyMapBriefManager from "./childDebriefFormsManager/body-map-manager";
import PersonCommentManager from "./childDebriefFormsManager/person-comment-manager";

const ChildDebriefManager = ({ task, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0); // Step index

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };


  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return (
          <PersonDebriefManager
            witnessData={task?.witnessData}
            debriefData={task?.personDebriefInfo}
            nextStep={nextStep}
          />
        );
      case 1:
        return (
          <BodyMapBriefManager
            bodayMapData={task?.bodyMapInfo}
            gender={task?.gender}
            prevStep={prevStep}
            nextStep={nextStep}
          />
        );
      case 2:
        return (
          <PersonCommentManager commentData={task?.personCommentInfo} prevStep={prevStep} handleSubmit={onClose} />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default ChildDebriefManager;
